import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const styles = {
  inheritFontWeight: {
    fontWeight: 'inherit',
  },
}

class RegulatoryOrganizations extends Component {
  _isMounted = false;

  state = {
    regulatoryOrganizations: [],
    status: 'fetching',
    message: null,
  }

  componentDidMount() {
    this._isMounted = true;

    this.props.handleFetchRegulatoryOrganizations(this.props.adminUserSession, this.props.riaContactId)
      .then(() => {
        if (this._isMounted && this.props.regulatoryOrganizations !== undefined) {
          const { status, message, regulatory_organizations } = this.props.regulatoryOrganizations;

          this.setState({
            regulatoryOrganizations: regulatory_organizations,
            status,
            message,
          })
        }
      })
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { classes } = this.props;
    const { regulatoryOrganizations } = this.state;

    return (
      <div>{regulatoryOrganizations.join(', ')}</div>
    )
  }

}

RegulatoryOrganizations.propTypes = {
  riaContactId: PropTypes.number.isRequired
}

export default withStyles(styles)(RegulatoryOrganizations);